import { render, staticRenderFns } from "./cpt-text-option.vue?vue&type=template&id=7fc6f566&scoped=true"
import script from "./cpt-text-option.vue?vue&type=script&lang=js"
export * from "./cpt-text-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6f566",
  null
  
)

export default component.exports